import ContactForm from '../components/contact';
import FormValidator from '../components/customFormValidator';
import MobileMenu from '../components/menu';

export default {
  init() {
    new MobileMenu();
    new ContactForm();
    new FormValidator();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js